var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgW6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e8cde3;\n        stroke: #9e1f63;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-2 {\n        fill: #9e1f63;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 21,
    cy: 21,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.15,19.94c.71-.84,1.48-1.47,2.31-1.88,.83-.41,1.77-.61,2.8-.61s1.9,.19,2.74,.55c.84,.37,1.57,.9,2.2,1.58,.63,.68,1.12,1.49,1.46,2.41,.34,.93,.52,1.9,.52,2.91,0,1.47-.34,2.8-1.01,4-.67,1.2-1.61,2.13-2.81,2.8s-2.57,1.01-4.09,1.01c-1.75,0-3.26-.43-4.53-1.28-1.27-.85-2.24-2.12-2.91-3.79s-1.01-3.72-1.01-6.13c0-1.97,.2-3.73,.61-5.28,.41-1.55,.99-2.84,1.75-3.86,.76-1.02,1.68-1.79,2.77-2.31,1.08-.52,2.32-.78,3.7-.78s2.51,.26,3.52,.78c1.02,.52,1.78,1.17,2.3,1.94,.52,.77,.77,1.51,.77,2.22,0,.43-.16,.82-.48,1.16-.32,.35-.73,.52-1.23,.52-.44,0-.84-.14-1.22-.41-.38-.28-.65-.66-.83-1.15-.24-.62-.62-1.13-1.14-1.51-.52-.38-1.12-.57-1.81-.57-.55,0-1.1,.16-1.65,.48-.55,.32-1.01,.75-1.38,1.29-.76,1.1-1.21,3.07-1.34,5.91Zm4.22,9.7c1.05,0,1.92-.43,2.61-1.29s1.03-1.99,1.03-3.38c0-.95-.16-1.76-.48-2.45-.32-.68-.77-1.2-1.33-1.56s-1.18-.54-1.86-.54-1.26,.17-1.85,.52c-.59,.34-1.06,.84-1.42,1.49-.36,.65-.54,1.41-.54,2.29,0,1.41,.36,2.58,1.09,3.52,.73,.94,1.65,1.41,2.75,1.41Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgW6);
export default __webpack_public_path__ + "static/media/W6.2b87825d9f5df8e317a9831fe50f9abb.svg";
export { ForwardRef as ReactComponent };